import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchGatepassCheckpointList = createAsyncThunk(
	"fetchGatepassCheckpointList",
	async ({ page = 1, limit = 10, start_date, end_date, status_id }, { rejectWithValue }) => {
		try {
			let url = `gatepass/getall?page=${page}&limit=${limit}&start_date=${start_date}T00:00:00.000Z&end_date=${end_date}T23:59:59.999Z`;
			if (status_id) {
				url += `&status_id=${status_id}`;
			}
			const response = await axiosHttp.get(url);
			return response.data;
		} catch (err) {
			if (!err.response) throw err;
			return rejectWithValue(err.response.data);
		}
	}
);

const GatepassCheckpointListSlice = createSlice({
	name: "GatepassCheckpointListSlice",
	initialState: {
		isLoading: false,
		data: [],
		error: null,
		page: 1,
		total: 0,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchGatepassCheckpointList.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(fetchGatepassCheckpointList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload?.data || [];
			state.page = action.payload?.pagination?.page || 1;
			state.total = action.payload?.pagination?.total || 0;
		});
		builder.addCase(fetchGatepassCheckpointList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default GatepassCheckpointListSlice.reducer;
